import {appVm} from "@/router"
import {RoleId} from "@/entities/role";
import {Policy} from '@/policies';
import logger from '@/logger';


export const SuperAdminPolicyOverride: Policy = {
	async can(): Promise<boolean | null> {
		const authUser = appVm.$store.state.authUser
		if (authUser.isAuthenticated && authUser.role?.id == RoleId.SuperAdmin) {
			return true;
		}
		return null;
	}
}

export default interface AuthorizationService {
	can(permission: string, context: unknown): Promise<boolean>;
}

export class AuthorizarionServiceWithOverride implements AuthorizationService {
	public overridingPolicy?: Policy;
	public policies: Map<string, Policy>;
	public allowIfPolicyNotSet: boolean;
	private log = logger.extend('AuthorizationService');
	constructor(policies: Map<string, Policy> = new Map(), overridingPolicy?: Policy, allowIfPolicyNotSet = false) {
		this.policies = policies;
		this.overridingPolicy = overridingPolicy;
		this.allowIfPolicyNotSet = allowIfPolicyNotSet;
	}

	public async can(permission: string, context?: unknown): Promise<boolean> {
		this.log('can %s with context %O', permission, context);
		if (this.overridingPolicy) {
			const result = await this.overridingPolicy.can(context);
			if (result != null) {
				this.log('can overriding result %O', result);
				return result;
			}
		}
		const policy = this.policies.get(permission);
		if (policy == undefined) {
			this.log('can if not set result %O', this.allowIfPolicyNotSet);
			return this.allowIfPolicyNotSet;
		}
		const result = await policy.can(context);
		if (result != null) {
			this.log('can result %O', result);
			return result;
		}
		this.log('can result %O', this.allowIfPolicyNotSet);
		return this.allowIfPolicyNotSet;
	}

}

